import { render, staticRenderFns } from "./MyReports.vue?vue&type=template&id=2387a2c6&"
import script from "./MyReports.vue?vue&type=script&lang=js&"
export * from "./MyReports.vue?vue&type=script&lang=js&"
import style0 from "./MyReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports